import React, { useState, useEffect, useContext } from "react";
import axios from "axios";
import {
    Card,
    Select,
    Row,
    Col,
    Spin,
    Typography,
    message,
    Space,
} from "antd";
import {
    PieChart,
    Pie,
    Cell,
    Tooltip,
    Legend,
    ResponsiveContainer,
} from "recharts";
import { AuthContext } from "../../context/AuthContext";

const { Title } = Typography;
const { Option } = Select;

const COLORS = [
    "#4CAF50",
    "#2196F3",
    "#FFC107",
    "#F44336",
    "#9C27B0",
    "#00BCD4",
    "#FF9800",
];

export default function StatutoryCompliance() {
    const { authData, backUrl } = useContext(AuthContext);
    const [data, setData] = useState([]);
    const [month, setMonth] = useState(new Date().getMonth() + 1);
    const [year, setYear] = useState(new Date().getFullYear());
    const [organisation, setOrganisation] = useState(1);
    const [organisations, setOrganisations] = useState([]);
    const [loading, setLoading] = useState(false);

    // Fetch organisation list for filter dropdown
    const fetchOrganisation = async () => {
        const res = await axios.get(`${backUrl}/api/emp/organisations/`, {
            headers: {
                Authorization: `Bearer ${authData?.access}`
            }
        })
        console.log("Org : ", res.data.results)
        setOrganisations(res.data.results)
    }

    useEffect(() => {
        fetchOrganisation()
    }, [])


    // Fetch statutory compliance data
    const fetchComplianceData = async () => {
        try {
            setLoading(true);
            const res = await axios.get(
                `${backUrl}/api/reports/statutory-compliance/?organisation_id=${organisation}&month=${month}&year=${year}`
            );
            const apiData = res.data;

            // Convert API response to chart format
            let chartData = Object.keys(apiData)
                .filter((key) => key !== "month" && key !== "year")
                .map((key) => ({
                    name: key.replace(/_/g, " ").toUpperCase(),
                    value: Number(apiData[key]),
                }));

            // If all values are 0 → show dummy data
            const totalValue = chartData.reduce((sum, item) => sum + item.value, 0);
            if (totalValue === 0) {
                chartData = [
                    { name: "PF", value: 45 },
                    { name: "ESI", value: 30 },
                    { name: "TDS", value: 25 },
                ];
            }

            setData(chartData);
        } catch (error) {
            console.error(error);
            message.error("Failed to fetch statutory compliance data");
        } finally {
            setLoading(false);
        }
    };

   

    useEffect(() => {
        fetchComplianceData();
    }, [organisation, month, year]);

    return (
        <Card
            style={{
                borderRadius: "12px",
                boxShadow: "0 2px 8px rgba(0,0,0,0.1)",
                padding: "20px",
            }}
        >
            {/* Filter Section */}
            <Row justify="space-between" align="middle" style={{ marginBottom: 16 }}>
                <Col>
                    <Title level={4}>Statutory Compliance Summary</Title>
                </Col>
                <Col>
                    <Space>
                        {/* Organisation Filter */}
                        <Select
                            value={organisation}
                            onChange={(value) => setOrganisation(value)}
                            style={{ width: 280 }}
                            placeholder="Select Organisation"
                        >
                            {organisations.map((item) => (
                        <Option key={item.id} value={item.id}>
                            {item.name}
                        </Option>
                    ))}
                        </Select>

                        {/* Month Filter */}
                        <Select
                            value={month}
                            onChange={(value) => setMonth(value)}
                            style={{ width: 120 }}
                        >
                            {[...Array(12)].map((_, i) => (
                                <Option key={i + 1} value={i + 1}>
                                    {new Date(0, i).toLocaleString("default", { month: "long" })}
                                </Option>
                            ))}
                        </Select>

                        {/* Year Filter */}
                        <Select
                            value={year}
                            onChange={(value) => setYear(value)}
                            style={{ width: 120 }}
                        >
                            {[2023, 2024, 2025, 2026].map((yr) => (
                                <Option key={yr} value={yr}>
                                    {yr}
                                </Option>
                            ))}
                        </Select>
                    </Space>
                </Col>
            </Row>

            {/* Chart Section */}
            {loading ? (
                <Spin tip="Loading compliance data..." />
            ) : (
                <ResponsiveContainer width="100%" height={350}>
                    <PieChart>
                        <Pie
                            dataKey="value"
                            data={data}
                            cx="50%"
                            cy="50%"
                            outerRadius={130}
                            fill="#8884d8"
                            label={({ name, value }) => `${name}: ${value}`}
                        >
                            {data.map((entry, index) => (
                                <Cell key={`cell-${index}`} fill={COLORS[index % COLORS.length]} />
                            ))}
                        </Pie>
                        <Tooltip />
                        <Legend />
                    </PieChart>
                </ResponsiveContainer>
            )}
        </Card>
    );
}
